<template>
  <div class="row" :style="rowStyle" :class="rowClass">
      <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'g-row',
    props: {
        gutter: {
            type: [String, Number]
        },
        align: {
            type: String,
            validator(value){
                return ['left','right','center'].includes(value)
            }
        }
    },
    mounted() {
        this.$children.forEach(item => {
            item.gutter = this.gutter
        })
    },
    computed: {
        rowStyle() {
            return {
                marginLeft:-this.gutter / 2 + 'px', marginRight:-this.gutter / 2 + 'px'
            }
        },
        rowClass() {
            return [
                this.align && `row-${this.align}`
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.row{
    display:flex;
    flex-wrap:wrap;
    &-left{
        justify-content: flex-start;
    }
    &-right{
        justify-content: flex-end;
    }
    &-center{
        justify-content: center;
    }
}
</style>